((document, window, history) => {
	let pushState = history.pushState;


		// Tolerance (px) is the size a viewport can chance
	// before updating css variables this prevents jerky
	// resizing when browser chrome disappears on mobile
	const tolerance = 60;

	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${ vh }px`);
	let lastHeight = window.innerHeight;

	let vw = window.innerWidth * 0.01;
	document.documentElement.style.setProperty('--vw', `${ vw }px`);
	let lastWidth = window.innerWidth;

	let header;

	if (document.querySelector('.site-header')) {
		header = document.querySelector('.site-header').getBoundingClientRect().height;
		document.documentElement.style.setProperty('--navbar-offset', header);
		if (document.querySelector('.pre-header')) {
			header += document.querySelector('.pre-header').getBoundingClientRect().height;
		}
		document.documentElement.style.setProperty('--nav-offset', header);
	}

	const resizeVars = () => {
		if (Math.abs(lastHeight - window.innerHeight) > tolerance) {
			vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${ vh }px`);
			lastHeight = window.innerHeight;
		}

		if (lastWidth != window.innerWidth) {
			vw = window.innerWidth * 0.01;
			document.documentElement.style.setProperty('--vw', `${ vw }px`);
			lastWidth = window.innerWidth;
		}

		if (document.querySelector('.site-header')) {
			header = document.querySelector('.site-header').getBoundingClientRect().height;
			document.documentElement.style.setProperty('--navbar-offset', header);
			if (document.querySelector('.pre-header')) {
				header += document.querySelector('.pre-header').getBoundingClientRect().height;
			}
			document.documentElement.style.setProperty('--nav-offset', header);
		}
	};
	window.addEventListener('resize', () => {
		resizeVars();
	});
	setTimeout(function() {
		resizeVars();
	}, 100);


	let resizeTimer;
	window.addEventListener("resize", () => {
	  document.body.classList.add("resize-animation-stopper");
	  clearTimeout(resizeTimer);
	  resizeTimer = setTimeout(() => {
		document.body.classList.remove("resize-animation-stopper");
	  }, 400);
	});

    // default cookie compliance script
    function cookieCompliance() {
		if (document.querySelector('.farlo-ui-biscuit-banner__button')) {
			document.querySelector('.farlo-ui-biscuit-banner__button').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');

				window._farlo.storage.set('cookieCompliance', 'true', 'cookie');
			});
		}

		if (document.querySelector('.farlo-ui-biscuit-banner__button--close')) {
			document.querySelector('.farlo-ui-biscuit-banner__button--close').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');
			});
		}
	}

    // default navicon
    function navicon() {
		document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle('site-navigation__navicon--active');document.querySelector('.site-navigation').classList.toggle('site-navigation__nav--active')
			document.body.classList.toggle('site-navigation__nav--open');
		});
	}

    history.pushState = function (state) {
        if (typeof history.onpushstate == "function") {
            history.onpushstate({ state: state });
        }
        return pushState.apply(history, arguments);
    };

    document.addEventListener("DOMContentLoaded", () => {
		document.documentElement.classList.add(_farlo.browser.init());

		//window._farloUi.init();

        if (document.querySelector('.site-navigation__navicon')) {
            navicon();
        }

        if (document.querySelector('.farlo-ui-biscuit-banner')) {
            cookieCompliance();
        }
    });


	var qty = document.querySelector(".cart > .quantity");
	if (qty) {
		document.querySelectorAll(".cart > .quantity").forEach(_el => {
			
			const q = _el.querySelector('.qty');
			const max = q.max || 9;
			const min = q.min;
			if (max) {

				let increaser = document.createElement("button");
				increaser.type = "button";
				increaser.classList.add("qty-control");
				increaser.classList.add("qty-up");
				increaser.innerHTML = "+";
				increaser.addEventListener("click",() => {
					const val = parseInt(q.value,10);
					if (val<max) {
						q.value = (parseInt(val,10)+1); 
					} else {
						q.value = max;
					}
				});

				let decreaser = document.createElement("button");
				decreaser.type = "button";
				decreaser.classList.add("qty-control");
				decreaser.classList.add("qty-down");
				decreaser.innerHTML = "-";
				decreaser.addEventListener("click",() => {
					const val = parseInt(q.value,10);

					if (val>min) {
						q.value = (parseInt(val,10)-1); 
					} else {
						q.value = min;
		
					}
				});

				_el.appendChild(decreaser);
				_el.appendChild(increaser);

			}

		});
	}


	var readMore = document.querySelector(".read-more");
	if (readMore) {
		document.querySelectorAll(".read-more").forEach(_btn => {
			_btn.addEventListener("click", () => {
				_btn.parentElement.classList.add("read-all");
				_btn.style.display = "none";
			})
		})

	}


	var _ukds_signup_form = null;
	var _ukds_signup_id =  'signup';


	function _ukdsMcSignup() {


		const signupFields = [
			document.querySelector("#FOOTER_NAME"),
			document.querySelector("#FOOTER_EMAIL"),
			document.querySelector("#FOOTER_GDPR")
		];

		let valid = true;
		for (let _i in signupFields) {
			switch(signupFields[_i].type) {
				case "email" : 
				if (!_farlo.helpers.validators.email(signupFields[_i].value)) {
					signupFields[_i].classList.add("invalid");
					valid = false;
				} else {
					signupFields[_i].classList.remove("invalid");
				}
				break;
				case "text" : 
				if (signupFields[_i].value == "") {
					signupFields[_i].classList.add("invalid");
					valid = false;
				} else {
					signupFields[_i].classList.remove("invalid");
				}
				break;
				case "checkbox" : 
				if (!signupFields[_i].checked) {
					signupFields[_i].classList.add("invalid");
					valid = false;
				} else {
					signupFields[_i].classList.remove("invalid");
				}

				break;

			}

		}
		if (valid) {
			if (_ukds_signup_form) {
				_ukds_signup_form.toggleForm();
			} else {
				_ukds_signup_form = new UKDS_MC({
						"validateFirst" : true,
						"formId" : _ukds_signup_id,
						"initData" : {
							"EMAIL": signupFields[1].value,
							"FNAME":	signupFields[0].value,
							"GDPR" : signupFields[2].checked
						}
				});
			}
		}
	}

	function _ukdsMcSignupBlank() {
		if (_ukds_signup_form) {
			_ukds_signup_form.toggleForm();
		} else {
			_ukds_signup_form = new UKDS_MC({
					"formId" : _ukds_signup_id,
			});
		}

	}

	function initialiseFormPopup(className, delay, cookieName, cookieDays) {
		// Check if the cookie already exists
		if (!getCookie(cookieName)) {
			// Wait for the specified delay
			setTimeout(() => {
				// Find the button with the specified class name
				const button = document.querySelector(`.${className}`);
				if (button) {
					// Programmatically trigger a click event
					button.click();
					// Set a cookie to track that the button has been clicked
					setCookie(cookieName, 'clicked', cookieDays);
				}
			}, delay);
		}
	}

	document.addEventListener('DOMContentLoaded', function () {
		initialiseFormPopup('mc-form-trigger-popup', 5000, 'buttonClicked', 28);
	});

	document.querySelectorAll(".toggle-mc-form").forEach((_sel) => {
		_sel.addEventListener("click", () => {
			if (_sel.dataset.mc_remindme) {
				document.getElementById("REMINDME").value = _sel.dataset.mc_remindme;
			}
			if (_sel.dataset.prompt) {
				document.getElementById("signup").querySelectorAll(".ukds-mc-tab")[0].querySelector("h3").innerText = _sel.dataset.prompt;
			}
			if (_sel.dataset.success) {
				document.getElementById("signup").querySelectorAll(".ukds-mc-tab")[1].querySelector("p").innerText = _sel.dataset.success;
			}
			
			_ukdsMcSignupBlank();
		});
	});
	document.addEventListener("click", function(e){
		if (document.querySelector(".farlo-ui-lightbox--active")) {
			const target = e.target.closest(".toggle-mc-form");
			if(target){
				if (target.dataset.mc_remindme) {
					document.getElementById("REMINDME").value = target.dataset.mc_remindme;
				}
				if (target.dataset.prompt) {
					document.getElementById("signup").querySelectorAll(".ukds-mc-tab")[0].querySelector("h3").innerText = target.dataset.prompt;
				}
				if (target.dataset.success) {
					document.getElementById("signup").querySelectorAll(".ukds-mc-tab")[1].querySelector("p").innerText = target.dataset.success;
				}
				document.body.classList.remove('body--farlo-ui-lightbox-open');
				target.closest('.farlo-ui-lightbox').classList.remove('farlo-ui-lightbox--active');
				_ukdsMcSignupBlank();
			}
	

		}
	  });


	document.querySelectorAll(".submit-mc-form").forEach((_sel) => {
		_sel.addEventListener("click", () => {
			_ukdsMcSignup();
		});
	});

	const youTubeRegex = RegExp(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i);


	function farloUiLightbox(elem, div) {
		if (elem.querySelector('.wp-block-image')) {
			elem.querySelector('.wp-block-image').addEventListener('click', function(e) {
				const clonedEmbed = e.currentTarget.closest('.wp-block-group').querySelector('.wp-block-embed').cloneNode(true);
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.farlo-ui-lightbox__inner-content').appendChild(clonedEmbed);
				div.classList.add('farlo-ui-lightbox--active');
			});
		}
	
		if (document.querySelector(elem.dataset.target)) {
			elem.addEventListener('click', function(e) {
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.farlo-ui-lightbox__inner-content').classList.add('dynamic');
				div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = document.querySelector(elem.dataset.target).innerHTML;
				div.classList.add('farlo-ui-lightbox--active');
			});


		}


		if (elem.nextElementSibling && elem.nextElementSibling.value) {
			elem.addEventListener('click', function(e) {
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.farlo-ui-lightbox__inner-content').classList.add('dynamic');
				if (e.target.nextElementSibling && e.target.nextElementSibling.value) {
					div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = e.target.nextElementSibling.value;
				}
				div.classList.add('farlo-ui-lightbox--active');
			});
		}
	
		if (elem.dataset.video) {
			elem.addEventListener('click', function(e) {
				e.preventDefault();
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = '<iframe class="farlo-ui-lightbox__inner-content-iframe" src="https://www.youtube-nocookie.com/embed/' + elem.dataset.video.match(youTubeRegex)[ 1 ] + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
				div.classList.add('farlo-ui-lightbox--active');
			});
		}

		if (elem.querySelector('a[href*="youtu.be"]')) {
			elem.querySelector('a[href*="youtu.be"]').addEventListener('click', function(e) {
				e.preventDefault();
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = '<iframe class="farlo-ui-lightbox__inner-content-iframe" src="https://www.youtube-nocookie.com/embed/' + e.currentTarget.href.match(youTubeRegex)[ 1 ] + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
				div.classList.add('farlo-ui-lightbox--active');
			});
		}
	
		if (div.querySelector('.farlo-ui-lightbox__button-close')) {
			div.querySelector('.farlo-ui-lightbox__button-close').addEventListener('click', function(e) {
				e.preventDefault();
				document.body.classList.remove('body--farlo-ui-lightbox-open');
				e.currentTarget.closest('.farlo-ui-lightbox').classList.remove('farlo-ui-lightbox--active');
				if (div.querySelector('.farlo-ui-lightbox__inner-content.dynamic')) {
					div.querySelector('.farlo-ui-lightbox__inner-content').classList.remove('dynamic');
				}
				div.querySelector('.farlo-ui-lightbox__inner-content').innerHTML = '';
	
				if (elem.classList.contains('site-geo-targeting')) {
					window._farlo.storage.set('geotargeted', 'true', 'cookie');
				}
			});
		}
	}


	const lightboxEmbed = document.querySelectorAll('.farlo-ui-lightbox__toggle, [data-video]');
	let div;
	let divInner;
	let divInnerContent;
	let divClose;

	if (lightboxEmbed.length > 0) {
		div = document.createElement('div');
		divInner = document.createElement('div');
		divInnerContent = document.createElement('div');
		divClose = document.createElement('button');
		div.className = 'farlo-ui-lightbox';
		divInner.className = 'farlo-ui-lightbox__inner';
		divInnerContent.className = 'farlo-ui-lightbox__inner-content';
		divClose.className = 'farlo-ui-lightbox__button-close';

		document.body.appendChild(div);
		document.querySelector('.farlo-ui-lightbox').appendChild(divInner);
		document.querySelector('.farlo-ui-lightbox__inner').appendChild(divInnerContent);
		document.querySelector('.farlo-ui-lightbox__inner').appendChild(divClose);

		lightboxEmbed.forEach(function(elem) {
			farloUiLightbox(elem, div);
		});
	}

	function toggleScrollIndication(_elem) {
		if (_elem.clientWidth < _elem.scrollWidth) {
			_elem.classList.add("scroll-overflow-x");
		} else {
			_elem.classList.remove("scroll-overflow-x");
		}
		if (_elem.clientHeight < _elem.scrollHeight) {
			_elem.classList.add("scroll-overflow-y");
		} else {
			_elem.classList.remove("scroll-overflow-y");
		}

	}


	const eventNavigation = document.querySelector("#event-navigation ul");
	if (eventNavigation) {
		window.addEventListener("resize", () => {
			toggleScrollIndication(eventNavigation);
		}); toggleScrollIndication(eventNavigation);
	}


	function toggleFAQ(_el,force) {
		let toggled = force ?? 0;
		if (typeof force === "undefined") {
			if(_el.dataset.toggled == "0") {
				toggled = 1;
			} else {
				toggled = 0;
			}
		}
		const _answer = _el.nextElementSibling;
		if (!toggled) {
			_answer.style.height = "0px";
		} else {
			_answer.style.height = _answer.scrollHeight + "px"
		}
		_el.dataset.toggled = toggled;
	}


	const faqItem = document.querySelector(".site-faqs__accordion-question");
	if (faqItem) {

		document.querySelectorAll(".site-faqs__accordion-question").forEach((_el) => {
			_el.dataset.toggled = "0";
			_el.addEventListener("click", () => {
				toggleFAQ(_el);
			})
		})

	}

	function initialisePerkLightbox() {
		function addLightboxClass(event) {
			event.preventDefault();
			var lightbox = event.target.nextElementSibling;
			lightbox.classList.add("lightbox--active");
		  }
		  
		  function removeLightboxClass(event) {
			event.preventDefault();
			var lightbox = event.target.closest(".lightbox");
			lightbox.classList.remove("lightbox--active");
		  }
		  
		  function handleClickOutsideLightbox(event) {
			var lightboxes = document.querySelectorAll(".lightbox");
		  
			for (var i = 0; i < lightboxes.length; i++) {
			  var lightboxContainer = lightboxes[i].querySelector(".lightbox__container");
			  if (
				lightboxes[i].classList.contains("lightbox--active") &&
				lightboxes[i] === event.target &&
				!lightboxContainer.contains(event.target)
			  ) {
				lightboxes[i].classList.remove("lightbox--active");
			  }
			}
		  }
		  
		  
		  var lightboxButtons = document.querySelectorAll(".button.lightbox-button");
		  lightboxButtons.forEach(function(button) {
			button.addEventListener("click", function(event) {
			  addLightboxClass(event);
			  event.stopPropagation();
			});
		  });
		  
		  var closeButtons = document.querySelectorAll(".button.lightbox-close");
		  closeButtons.forEach(function(button) {
			button.addEventListener("click", removeLightboxClass);
		  });
		  
		  document.addEventListener("click", handleClickOutsideLightbox);
		  
	}

	if(document.querySelector(".perks")) {
		initialisePerkLightbox();
	}


	function pageScroll(target,offset) {
		var elem = document.querySelector(target);
		if (elem) {
			var scroll = (window.pageYOffset + elem.getBoundingClientRect().top) - window.getComputedStyle(document.documentElement).getPropertyValue('--nav-offset');
			if (typeof offset != "undefined") {
				scroll = scroll-offset;
			}
			window.scroll({
				top : scroll,
				behavior : 'smooth'
			})

		}
	}

	function handleFormSubmit(event) {
		event.preventDefault(); // Prevents the form from submitting and refreshing the page
		
		var passwordInput = document.querySelector('.password__form input[type="password"]');
		var passwordDiv = document.querySelector('.password');
		var passwordError = document.querySelector('.pw-error');
	  
		if (passwordInput.value === 'menier') {
		  passwordDiv.classList.remove('password--active');
		  setCookie('loggedIn', 'true', 1); // Set a cookie to indicate that the user is logged in for 1 day
		} else {
		  passwordError.textContent = "Password incorrect";
		}
	  }
	  
	  function setCookie(name, value, days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		var expires = "expires=" + date.toUTCString();
		document.cookie = name + "=" + value + "; " + expires + "; path=/";
	  }
	  
	  function getCookie(name) {
		var cookieName = name + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var cookieArray = decodedCookie.split(';');
	  
		for (var i = 0; i < cookieArray.length; i++) {
		  var cookie = cookieArray[i];
		  while (cookie.charAt(0) === ' ') {
			cookie = cookie.substring(1);
		  }
		  if (cookie.indexOf(cookieName) === 0) {
			return cookie.substring(cookieName.length, cookie.length);
		  }
		}
	  
		return "";
	  }
	  
	  if (document.querySelector('.password')) {
		var form = document.querySelector('.password__form');
		form.addEventListener('submit', handleFormSubmit);
	  }
	  
	  // Check if the user is logged in based on the cookie
	  var isLoggedIn = getCookie('loggedIn') === 'true';
	  if (isLoggedIn) {
		var passwordDiv = document.querySelector('.password');
		passwordDiv.classList.remove('password--active');
	  }
	  


	document.querySelectorAll("a").forEach(elem => {
		if (elem.href) {
			if (_farlo.helpers.urls.isHash(elem)) {
				elem.addEventListener("click", (e) => {
					e.preventDefault();
					let url = elem.href.split("#");
						let selector = "#" + url[1];
						if (selector!== "#") {
							if (document.querySelector(selector)) {
								pageScroll(selector);
							} else {
								document.location.href = elem.href;
							}
						}
				});
			}  
		}
	});
	if (document.location.hash) {
		let url = document.location.href.split("#");
		let selector = "#" + url[1];
		try {
			if (document.querySelector(selector)) {
				pageScroll(selector);
			}
		} catch(ex) {
			
		}
	}

	

})(document, window, history);